import { render, staticRenderFns } from "./ModalDuplicateActivity.vue?vue&type=template&id=7bb3e9b2&scoped=true&lang=html&"
import script from "./ModalDuplicateActivity.vue?vue&type=script&lang=ts&"
export * from "./ModalDuplicateActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb3e9b2",
  null
  
)

export default component.exports